import { BridgeComponent } from "@hotwired/hotwire-native-bridge"
import { BridgeElement } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "form"
  static targets = ["submit"]

  connect() {
    super.connect()
    // When multiple forms share a screen (e.g. tabbed modal), only the visible
    // form may own the native navbar Guardar. Hidden ones skip connect; tabs
    // call activate() when their panel becomes visible.
    if (this.#isInHiddenPanel()) return

    this.notifyBridgeOfConnect()
  }

  activate() {
    this.notifyBridgeOfConnect()
  }

  notifyBridgeOfConnect() {
    const submitButton = new BridgeElement(this.submitTarget)
    const submitTitle = submitButton.title
    const submitDisabled = submitButton.disabled
    // data-bridge-show-dismiss="false" para pantallas empujadas al stack donde no debe usarse dismiss.
    const showDismissAttr = this.bridgeElement.bridgeAttribute("show-dismiss")
    const showDismiss = showDismissAttr !== "false"

    this.send("connect", { submitTitle, submitDisabled, showDismiss }, () => {
      this.submitTarget.click()
    })
  }

  submitStart(event) {
    this.submitTarget.disabled = true
    this.send("submitDisabled")
  }

  submitEnd(event) {
    this.submitTarget.disabled = false
    this.send("submitEnabled")
  }

  #isInHiddenPanel() {
    return this.element.closest(".hidden") != null
  }
}
